import React from 'react'
import { Box, Chip, Typography } from '@mui/material'
import ThumbUpIcon from '@mui/icons-material/ThumbUp'
import ThumbDownIcon from '@mui/icons-material/ThumbDown'
import { useTheme } from '@mui/material/styles'
import { getMessageFeedbackReasonLabel, getJobFeedbackReasonLabel } from 'src/pages/Super/ChatbotConversations/helpers'

const FEEDBACK_TYPE_JOB = 1

const InlineFeedbackDisplay = ({ feedback }) => {
  const theme = useTheme()
  const isPositive = feedback.vote === 1
  const isJobFeedback = feedback.feedbackType === FEEDBACK_TYPE_JOB

  const reasons = isJobFeedback
    ? (feedback.jobReasons ?? []).map(index => getJobFeedbackReasonLabel(index, isPositive))
    : (feedback.messageReasons ?? []).map(index => getMessageFeedbackReasonLabel(index, isPositive))

  return (
    <Box
      sx={{
        mt: 1,
        p: 1,
        borderRadius: 1,
        border: `1px solid ${theme.palette.grey[200]}`,
        bgcolor: theme.palette.grey[50],
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: reasons.length > 0 ? 1 : 0 }}>
        {isPositive ? (
          <ThumbUpIcon sx={{ fontSize: '0.875rem', color: theme.palette.success.main }} />
        ) : (
          <ThumbDownIcon sx={{ fontSize: '0.875rem', color: theme.palette.error.main }} />
        )}
        <Typography variant='caption' color='textSecondary'>
          {isPositive ? 'Positive feedback' : 'Negative feedback'}
        </Typography>
        {isJobFeedback && feedback.jobId && (
          <Typography variant='caption' color='textSecondary'>
            Job ID: {feedback.jobId}
          </Typography>
        )}
      </Box>

      {reasons.length > 0 && (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: feedback.comment ? 1 : 0 }}>
          {reasons.map(label => (
            <Chip key={label} label={label} size='small' variant='outlined' />
          ))}
        </Box>
      )}

      {feedback.comment && (
        <Typography variant='caption' sx={{ color: theme.palette.grey[700], display: 'block' }}>
          "{feedback.comment}"
        </Typography>
      )}
    </Box>
  )
}

export default InlineFeedbackDisplay
